import { render, staticRenderFns } from "./PopupEditShift.vue?vue&type=template&id=46e7f9bb&scoped=true&"
import script from "./PopupEditShift.vue?vue&type=script&lang=ts&"
export * from "./PopupEditShift.vue?vue&type=script&lang=ts&"
import style0 from "./PopupEditShift.vue?vue&type=style&index=0&id=46e7f9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7f9bb",
  null
  
)

export default component.exports